var _path, _rect, _line, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10C4.5 6.68629 7.18629 4 10.5 4H30.5C33.8137 4 36.5 6.68629 36.5 10V14H4.5V10Z",
    fill: "#FFCC00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 14,
    x2: 35.5,
    y2: 14,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2074 27.255C17.3874 28.995 18.7824 30.12 20.5674 30.12C22.6674 30.12 24.0174 28.635 24.0174 26.52C24.0174 24.465 22.9974 23.04 20.8074 23.04C20.2374 23.04 19.7274 23.19 19.3224 23.43L19.5624 21.24H23.4174V19.5H18.0174L17.4324 25.41L18.6174 25.65C19.1124 25.095 19.7724 24.705 20.4774 24.705C21.5424 24.705 22.1274 25.35 22.1274 26.52C22.1274 27.705 21.5874 28.38 20.5674 28.38C19.8774 28.38 19.2174 28.08 18.9924 26.925L17.2074 27.255Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar5);
export default __webpack_public_path__ + "static/media/calendar-5.98fe99f7be56c6378482d7d10e279d84.svg";
export { ForwardRef as ReactComponent };